import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col, Modal } from "react-bootstrap";
import { apiService } from "../../../service/ApiService";
import { useHistory } from "react-router-dom";
import { notificationService } from "../../../service/NotificationService";
import HippoTable from "../../../components/ReactTable/HipposReactTable";
import CreateTableBtn from "components/Buttons/CreateTableBtn";
import EditButton from "views/Components/EditButton";
import DeleteButton from "views/Components/DeleteButton";
import CreditsButton from "views/Components/CreditsButton";
import { ClipLoader } from "react-spinners";

import SweetAlert from "react-bootstrap-sweetalert";

import { useTranslation } from "react-i18next";

function UserListPage() {
  const {
    t,
  } = useTranslation();

  const history = useHistory();
  const [data, setData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [alert, setAlert] = useState(null);
  const [showLoader, setShowLoader] = useState(true);

  const [topUpId, setTopUpId] = useState(0);
  const [topUpUsername, setTopUpUsername] = useState("");
  const [topUpCredits, setTopUpCredits] = useState(0);

  const columns = [
    {
      Header: "ID",
      accessor: "id",
      maxWidth: 70,
      minWidth: 40,
      width: 60,
    },
    {
      Header: t("tables.headers.username"),
      accessor: "username",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.fullName"),
      accessor: "fullName",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.role"),
      accessor: "roleName",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("common.labels.credits"),
      accessor: "credits",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.actions"),
      accessor: "actions",
      minWidth: 200,
      maxWidth: 300,
      width: 100,
    },
  ];

  const fetchData = async () => {
    setShowLoader(true);
    try {
      const dataResponse = await apiService.get("api/v1/users");
      setData(attachCustom(dataResponse.data));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const attachCustom = (data) => {
      const enhanced = data.map((el) => {
        el.actions = (
          <div className="actions-right d-flex float-right">
            {apiService.isSuperAdmin() && el.roleName === "Reseller" ? (
              <CreditsButton handler={() => handleModalShow(el.id, el.username)} />
            ) : null}
            <EditButton uri={`/admin/user/${el.id}`} />
            <DeleteButton handler={() => showUserDeleteAlert(el)} />
          </div>
        );
        el.role = el.role ? el.role.name : "";
        el.credits = el.credits > 0 ? el.credits : "";
        return el;
      });
      return _.sortBy(enhanced, ["order", "id"]);
    };

  useEffect(() => {
    fetchData();
  }, []);

  const handleModalShow = (id, username) => {
    setTopUpCredits(0);
    setTopUpId(id);
    setTopUpUsername(username);
    setModalShow(true);
  };

  const handleModalClose = (event) => {
    event.preventDefault();
    setTopUpId(0);
    setTopUpUsername("");
    setModalShow(false);
  };

  const handleModalSubmit = (event) => {
    event.preventDefault();
    if (topUpCredits <= 0) return;
    apiService
      .topUp(topUpId, topUpCredits)
      .then((newCredits) => {
        notificationService.notify(
          `${t("messages.theTopUpForUserSuffix")}${topUpUsername}${t("messages.completedSuccessfullyNewCreditsSuffixPrefix")}${newCredits.credits}`,
        );
        setModalShow(false);
        fetchData();
      })
      .catch((error) => {
        console.log(error);
        notificationService.notifyError(`${t("messages.somethingWentWrongWithTheTopUpForUserSuffix")}${topUpUsername}.`);
      });
  };

  const handleUserDelete = (id) => {
    setAlert(null);

    apiService
      .delete(`api/v1/users/${id}`)
      .then((resp) => {
        notificationService.notifySuccess(t("messages.userDeletedSuccessfully"));
        fetchData();
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
      });
  };

  const showUserDeleteAlert = (user) => {
    setAlert(
      <SweetAlert
        warning
        title={t("messages.deleteUser")}
        onConfirm={() => handleUserDelete(user.id)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        confirmBtnText={t("messages.delete")}
        cancelBtnText={t("common.actions.cancel")}
        showCancel
      >{t("messages.areYouSureYouWantToDeleteUser")}{user.username}{t("messages.value")}</SweetAlert>
    );
  };

  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Body>
                <Row>
                  <CreateTableBtn route={"/admin/user"} />
                </Row>
                <Row>
                  <Col>
                    {showLoader ? (
                      <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
                        <ClipLoader size={50} color={"#ff6fbc"} />
                      </div>
                    ) : (
                      <HippoTable HippoTable data={data} columns={columns} className="-striped -highlight primary-pagination"/>
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal show={modalShow} onHide={handleModalClose}>
        <Modal.Header>
          <Modal.Title>Top Up: {topUpUsername}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="numberInput">
              <Form.Label>{t("common.labels.credits")}</Form.Label>
              <Form.Control
                type="number"
                value={topUpCredits}
                min={1}
                onChange={(e) => setTopUpCredits(Number(e.target.value))}
                placeholder={t("common.labels.credits")}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={(event) => handleModalClose(event)} type="submit">{t("common.labels.cancellation")}</Button>
          <Button className="btn-wd mr-1" variant="primary" type="submit" onClick={(event) => handleModalSubmit(event)}>
            Top Up
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UserListPage;
